<template>
     <v-snackbar
      v-model="message.message.show"
      :timeout= "message.message.timeout"
      top
    >
      {{ message.message.context }}
      <v-btn
        color="pink"
        text        
        @click="close"
      >
        Закрыть
      </v-btn>
    </v-snackbar>
</template>

<script>

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

export default {
    name:"Message",  	
    data: ()=> ({
        showMessage: false,
        textMessage:'',
        

    }),

    computed: {
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },
        message: {
            get() {
                return this.$store.state.message;
            },
            set(value) {
                this.$store.dispatch("getMessage", value);
            }
        }
    },
  methods: {
    close: function() {
      
      if(DEBUG) console.log('call message', this.message);
     this.$store.dispatch("hideMessage");
      
      
    },
    },

}
</script>
